import { Injectable } from '@angular/core';
import { Observable } from '../../../node_modules/rxjs';
import { HttpClient, HttpHeaders } from '../../../node_modules/@angular/common/http';
import { API_SETTINGS } from '../api-services/API_SETTINGS';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(
    public httpClient: HttpClient
  ) { }

  recordFeedback(name, email, phone, category, message) {
    // this.startRecordFeedback(name, email, phone, category, message).subscribe(() => {
    //   // Feedback recorded;

    // });
  }

  startRecordFeedback(name, email, phone, category, message): Observable<any> {
    var url = API_SETTINGS.API_URL + "slack/" + encodeURIComponent(name) + "/" + encodeURIComponent(email) + "/" + encodeURIComponent(phone) + "/" + encodeURIComponent(category) + "/" + encodeURIComponent(message);
    return this.httpClient.get<any>(url);
  }

  submitFeedback(Feedback): Observable<any> {
    var url = API_SETTINGS.API_URL + 'Feedback/SendFeedback';
    return this.httpClient.post<any>(url, Feedback, httpOptions).pipe();
  }
}
